let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("is2fC")).then(() => parcelRequire('h88zC'));